import React from 'react';
import { useRecoilValue } from 'recoil';
import { ColorUpsellModal } from '../../cart/components/ColorUpsellModal';
import { ViewVariant } from '../../models/ShopifyVariant.model';
import { isMobileState } from '../../recoil/selectors';
import { useSetModalState } from './useModalState';
import { ModalToggleState } from '../../models/actionStates';
import { SelectionType } from '../../enums/SelectionType.enum';

export enum PreCartModals {
  ColorUpsell = 'ColorUpsell',
}
export const usePreCartModal = (variant: ViewVariant | undefined, selectionType: SelectionType): ((modalType: PreCartModals) => void) => {
  const isMobile = useRecoilValue(isMobileState);
  const setModal = useSetModalState();
  const modalHeightWidth = isMobile ? '100vw' : '750px';
  return () => {
    if (
      variant &&
      !['SSBF', 'SSTG'].some((sku) => variant.sku.includes(sku)) // don't upsell bundles
    ) {
      const isGiftCard = variant.name.toLowerCase().includes('gift card');
      const showModal = !isGiftCard;
      const contents = <ColorUpsellModal variant={variant} selectionType={selectionType} />;
      showModal &&
        setModal({
          contents,
          width: modalHeightWidth,
          maxWidth: '100vw',
          height: isMobile ? '100vh' : 'unset',
          maxHeight: 'unset',
          toggleState: ModalToggleState.Open,
          scrollToTop: false,
          isBaseState: false,
        });
    }
  };
};
